<template>
    <div class="countdown d-flex w-100 justify-content-center">
        <div v-if="useDays" class="block">
            <p class="digit">{{ days | twoDigits}}:</p>
        </div>
        <div class="block">
            <p class="digit">{{ hours | twoDigits}}:</p>
        </div>
        <div class="block">
            <p class="digit">{{ minutes | twoDigits}}:</p>
        </div>
        <div class="block">
            <p class="digit">{{ seconds | twoDigits}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Counter",
        components: {},
        props: {
            date: {
                type: String
            },
            useDays: {
                type: Boolean
            }
        },
        data: function () {
            return {
                now: Math.trunc((new Date()).getTime() / 1000)
            };
        },
        computed: {
            // dateInMilliseconds() {
            //     return Math.trunc(Date.parse(this.date) / 1000)
            // },
            seconds() {
                return (this.dateInMilliseconds - this.now) % 60;
            },
            minutes() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
            },
            hours() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60);
            },
            days() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
            }
        },
        created(){
            // dateInMilliseconds does not belong to props or data
            // because no reactivity is required (better performance)
            this.dateInMilliseconds = Math.trunc(Date.parse(this.date) / 1000);
        },
        mounted() {
            window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000);
            },1000);
        },
        filters: {
            twoDigits: function(value){
                if (value < 0) {
                    return '00';
                }
                if (value.toString().length <= 1) {
                    return `0${value}`;
                }
                return value;
            }
        }
    };
</script>
